import React, { useEffect } from "react";
import { useState } from "react";
import AddActivity from "./AddActivity";
import AddVirtualBusiness from "./AddVirtualBusiness";
import { addCompany, selectedCompanyStepAction, selectPendingCompany } from "../../actions/company";
import { PREDEFINED_ADDRESS } from "../../constants";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import GetToaster from "../header/getToaster";
import CompanySteps from "./CompanySteps";
import AddObjective from "./AddObjective";
import VerifyBusiness from "./VerifyBusiness";
import { RoutesPaths } from "../../Router/constant";
import { useSearchParams } from "react-router-dom";

export default function AddModal() {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const [newdata, setNewData] = useState({});
  const navigate = useNavigate()
  const { pendingCompanySelected, selectedCompanyStep, pendingCompany } = useSelector((state) => state.company);
  const { toastMessage } = useSelector(state => state.message)
  const [businessData, setBusinessData] = useState({});

  const dispatch = useDispatch();

  watch(["logo"]);

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useEffect(() => {
    if (id) {
      var resp = pendingCompany?.filter(x => x.id === id)[0];
      dispatch(selectPendingCompany(resp));

    }
  }, [pendingCompany, dispatch, id])


  const updateForm = async (data, type) => {
    if ("logo" in data && data?.logo?.length === 0) {
      data.logo = "";
    }
    let resp = null;
    let companyRes = null;
    let payload = {
      companyName: data?.companyName,
      companyWebsite: data?.companyWebsite,
      city: PREDEFINED_ADDRESS.CITY,
      country: PREDEFINED_ADDRESS.COUNTRY,
      postalCode: PREDEFINED_ADDRESS.POSTAL_CODE,
      primaryAddress: PREDEFINED_ADDRESS.LINE1,
      logo: data.logo,
      id: pendingCompanySelected ? pendingCompanySelected?.id : null,
      isTick: data.isTick,
      about: data.about,
    };

    if (data?.companyName?.trimLeft().length > 0) {
      resp = await dispatch(addCompany(payload, false));
      return resp;
    }
  };

  const onSubmit = async (data) => {
    if (data?.companyName?.trimLeft().length > 0) {
      const successCompanyResp = await updateForm(data, true);
      if (successCompanyResp.status) {
        setNewData(data);
        dispatch(selectedCompanyStepAction(2))
        navigate(`${RoutesPaths.ADD_COMPANY}?id=${successCompanyResp?.data?.id}`, { replace: true });
        reset();
      }
    }
  };

  const handleClose = async () => {
    let data = {
      companyName: getValues("companyName") || null,
      companyWebsite: getValues("companyWebsite") || null,
      logo: getValues("logo") || null,
      isTick: getValues("isTick") || null,
      about: getValues("about") || null,

    };
    await updateForm(data, false);
    navigate(RoutesPaths.DASHBOARD, { replace: true })
    dispatch(selectedCompanyStepAction(1))
    dispatch(selectPendingCompany(null));
    reset();
  };

  return (
    <div className="buyProductSectionBgScroll">
      <div className="container-fluid">
        {toastMessage && <GetToaster />}
        <CompanySteps selectedStep={selectedCompanyStep} />
      </div>
      <div className="container bankPage">
        <div className="row buyProductSection">
          <div className="col-md-8">
            <div className="container">
              <div className="row buyProductSectionBg">
                <div className="col-md-12">
                  <div className="userDetail">

                    {selectedCompanyStep === 1 ?
                      <AddVirtualBusiness register={register} handleSubmit={handleSubmit} getValues={getValues} onSubmit={onSubmit} setValue={setValue} errors={errors} handleClose={handleClose} />
                      : selectedCompanyStep === 2 ? <AddActivity newdata={newdata} setBusinessData={setBusinessData} />
                        : selectedCompanyStep === 3 ? <AddObjective businessData={businessData} />
                          : <VerifyBusiness />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}
